import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { FormatTypeCopySink } from './format-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { OrcDataset } from 'app/model/dataset/orc.dataset';

@Metamodel.model({
    name: adfModelTypeMap.orc.copySinkType,
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(OrcDataset) }
})
export class OrcSink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;
}
